// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { styled } from '@mui/material/styles';
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { GlobalEvent, GlobalState } from './GlobalContext'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DocDListGridEdit from './DocDListGridEdit';
import SelMemberDialog from './SelMemberDialog';
import MsgDialog from './MsgDialog';
import Backdrop from '@mui/material/Backdrop';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import InputAdornment from '@mui/material/InputAdornment';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import CssBaseline from '@mui/material/CssBaseline';



export default function UploadFilesDialog(props) {

  const { sysID, folderID, open, onClose, onUpload } = props;


  const filesLimit = 30;
  const iniFiles = (props.iniFiles || []).slice(0, filesLimit);



  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);


  const [selFiles, setSelFiles] = useState(iniFiles);

  // const [disabledUpload, setDisabledUpload] = useState(true);
  const disabledUpload = (selFiles.length === 0);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [distData, setDistData] = useState([]);

  const [anchorElAdd, setAnchorElAdd] = useState(null);
  const openAddDialog = Boolean(anchorElAdd);
  const handleAddClick = (event) => {
    setAnchorElAdd(event.currentTarget);
  };
  const handleCloseAddMenu = () => {
    setAnchorElAdd(null);
  };

  const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
  const [allFolderUsers, setAllFolderUsers] = useState([]);
  // const [members, setMembers] = useState([]);
  const [groups, setGroups] = useState([]);

  const onCatchPromiseError = (e) => {
    const msg = typeof e === "string" ? e : (e?.errMsg || e?.message || "Unknown Error");
    setErrMsg(msg);
    setShowError(true);
    gEventDispatch({
      showErr: true,
      err: e,
    });
  }

  const initData = () => {
    setDistData([]);
    setSelectedRecs([]);
  }

  useEffect(() => {

    if (open === true) {
      initData();

      setSelFiles(iniFiles);

      const xFunc = async () => {

        try {

          const [vAllFolderUsers, , vGroups] =
            await DmsService.getFolderAccessibleUsersPromise(gState.sessionID, sysID, folderID);
          setAllFolderUsers(vAllFolderUsers);
          // setMembers(vMembers);
          setGroups(vGroups);
        } catch (e) {
          onCatchPromiseError(e);
        }


      }
      xFunc();
    }

  }, [open])

  const handleAddByUser = async () => {
    setAnchorElAdd(null);


    setOpenAddUserDialog(true);
  };

  const handleSelectAddUsers = (aUsers, aGroups) => {
    // console.log("handleSelectAddUsers", aUsers, aGroups);
    // console.log("aGroups", aGroups);

    setOpenAddUserDialog(false);

    let vData = distData.map(item => {
      return item
    });


    aUsers.forEach(addUser => {
      const vFound = vData.find(f => f.ToUserID.toLowerCase() === addUser.UserID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "ActionReq": 0,
          "DeptName": addUser.Department,
          "ToUserID": addUser.UserID,
          "ToUserName": addUser.FullName,
          "IsUser": true,
        }

        vData.push(vNewItem);

      }
    });

    aGroups.forEach(addGroup => {
      const vFound = vData.find(f => f.ToUserID.toLowerCase() === addGroup.GroupID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "ActionReq": 0,
          "DeptName": "",
          "ToUserID": addGroup.GroupID,
          // "ToUserName": addGroup.GroupNameDisplay,
          "ToUserName": addGroup.Name,
          "IsUser": false,

        }

        vData.push(vNewItem);

      }
    });

    // console.log("vData", vData);
    setDistData(vData);
    setSelectedRecs([]);

  }

  const handleAddAllAuthUsers = async () => {
    // console.log("handleAddAllAuthUsers");

    setAnchorElAdd(null);

    setShowLoading(true);

    try {

      let vData = distData.map(item => {
        return item
      });

      let vHasUpdate = false;

      allFolderUsers.forEach(addUser => {
        const vFound = vData.find(f => f.ToUserID.toLowerCase() === addUser.UserID.toLowerCase());
        if (!vFound) {
          // console.log("addUser", addUser);
          const vNewItem = {
            "ActionReq": 0,
            "DeptName": addUser.Department,
            "ToUserID": addUser.UserID,
            "ToUserName": addUser.FullName,
            "IsUser": true,
          }

          vData.push(vNewItem);

          vHasUpdate = true;
        }
      });

      if (vHasUpdate === true) {
        // console.log("vData", vData);
        setDistData(vData);
        setSelectedRecs([]);
      }

      setShowLoading(false);
    } catch (e) {
      setShowLoading(false);
      setErrMsg(e.errMsg || e.message);
      setShowError(true);
    };





  };



  const handleActionChange = (aRecord, aNewValue) => {
    // console.log("handleActionChange", aCurIdx, aNewValue);

    const vNewGridData = distData.map((d, idx) => {
      if (d.ToUserID == aRecord.ToUserID) {
        return {
          ...d,
          "ActionReq": aNewValue,
        }
      } else {
        return d;
      }
    });

    setDistData(vNewGridData);
  };

  const handleRemove = () => {
    // console.log("handleRemove selectedRecs", selectedRecs);

    const vData = distData.filter(d => !selectedRecs.some(r => r.ToUserID === d.ToUserID));
    setDistData(vData);
    setSelectedRecs([]);

  }




  const [selectedRecs, setSelectedRecs] = useState([]);

  const handleSelectionChange = (aRecords) => {

    setSelectedRecs(aRecords);

  }


  const handleCloseClick = () => {

    onClose && onClose();
  }

  const handleUploadClick = () => {
    // console.log("Files: ", selFiles);
    const oversizedFiles = selFiles.filter(f => f.size > DmsCommon.MAX_FILE_SIZE).map(f => f.name);
    if (oversizedFiles.length > 0) {
      setErrMsg(oversizedFiles.length === 1 ? "File size exceeds 2GB limit!" : `File size exceeds 2GB limit: ${oversizedFiles.join(', ')}`);
      setShowError(true);
      return;
    }

    const vDistList = distData.map(d => {
      return {
        "UserID": d.ToUserID,
        "ActionReq": d.ActionReq,
      }
    })

    onUpload && onUpload(selFiles, vDistList);

  }


  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: filesLimit,
    onDrop: aDropfiles => {
      // console.log('onDrop', files);
      // const newSelFiles = [...selFiles, ...files];
      // setSelFiles(newSelFiles);

      let newFiles = [...selFiles];
      aDropfiles.forEach((aFile) => {
        if (!newFiles.some(f => f.name === aFile.name)) {
          newFiles.push(aFile);
        }
      })
      newFiles = newFiles.slice(0, filesLimit);

      setSelFiles(newFiles);
    }
  });

  const handleDeleteClip = (aFile) => {
    // console.log('handleDeleteClip', aFile);

    setSelFiles((selFiles) => selFiles.filter((f) => f.name !== aFile.name));
  }


  const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  return (
    <React.Fragment>
      <CssBaseline />
      <Dialog
        open={open}
        // onClose={handleCloseClick}
        aria-describedby="alert-dialog-description"
        sx={{ '& .MuiDialog-paper': { width: '80%' } }}
        maxWidth="md"
      >
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <MsgDialog
          open={showError}
          title="Error"
          msgText={errMsg}
          onClose={() => setShowError(false)}
        />

        <SelMemberDialog
          open={openAddUserDialog}
          onClose={() => { setOpenAddUserDialog(false) }}
          members={allFolderUsers}
          groups={groups}
          onSelect={handleSelectAddUsers}
        />

        <DialogContent>

          <section className="container">
            <div {...getRootProps({ className: 'dropzone' })}>
              <input {...getInputProps()} />
              <p>Drag and drop files here or click</p>
            </div>
          </section>
          Selected files {`(max. ${filesLimit} files)`}
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              listStyle: 'none',
              p: 0.5,
              m: 0,
            }}
            component="ul"
          >
            {selFiles.map((f, idx) => {

              return (
                <ListItem key={`${idx}_${f.name}`}>
                  <Chip
                    label={f.name}
                    onDelete={() => handleDeleteClip(f)}
                  />
                </ListItem>
              );
            })}
          </Box>

          <Box sx={{ pt: 2, px: 1 }}  >
            Distribution List
          </Box>

          <Box sx={{ py: 0, px: 1 }}  >
            <Button
              id="add-button"
              aria-controls="add-menu"
              aria-haspopup="true"
              aria-expanded={openAddDialog ? 'true' : undefined}
              startIcon={<PersonAddAlt1Icon />}
              onClick={handleAddClick}
            >
              Add
            </Button>
            <Menu
              id="add-menu"
              anchorEl={anchorElAdd}
              open={openAddDialog}
              onClose={handleCloseAddMenu}
              MenuListProps={{
                'aria-labelledby': 'add-button',
              }}
            >
              <MenuItem onClick={handleAddByUser}>Users</MenuItem>
              <MenuItem onClick={handleAddAllAuthUsers}>All Authorized Users</MenuItem>
            </Menu>

            <Button startIcon={<PersonRemoveIcon />} disabled={selectedRecs.length == 0} onClick={handleRemove}>
              Remove
            </Button>


          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', height: "30vh" }} >
            <DocDListGridEdit
              gridData={distData}
              onActionChange={handleActionChange}
              onSelectChange={handleSelectionChange}
            />

          </Box>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseClick}>Cancel</Button>

          <Button variant="contained" disabled={disabledUpload} onClick={handleUploadClick}>Upload</Button>
        </DialogActions>
      </Dialog>

    </React.Fragment>

  );
}

UploadFilesDialog.propTypes = {
  sysID: PropTypes.string,
  folderID: PropTypes.number,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onUpload: PropTypes.func,
  iniFiles: PropTypes.array,
};
